import { render, staticRenderFns } from "./ObjectNewSingle.vue?vue&type=template&id=3ef86781&"
import script from "./ObjectNewSingle.vue?vue&type=script&lang=js&"
export * from "./ObjectNewSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports